module.exports = __webpack_public_path__ + "static/media/corePrinciples.f8410f13.svg";